export const findTopicByActionIdentifier = (topicsArray = [], actionIdentifier) => {
    return (topicsArray.filter(t => t.actionIdentifier === actionIdentifier)[0] || {})
        .title;
};

export const getCachedFullName = state => {
    return state.cachedFormData.fullName
        ? `${state.cachedFormData.fullName.split(' ')[0]} ${state.cachedFormData.fullName.split(' ').pop()}`
        : state.cachedFormData.firstName && state.cachedFormData.lastName
        ? `${state.cachedFormData.firstName} ${state.cachedFormData.lastName}`
        : ``;
};

export const getCachedFirstName = state => {
    return state.cachedFormData.firstName
        ? state.cachedFormData.firstName
        : state.cachedFormData.fullName
        ? state.cachedFormData.fullName.split(' ')[0]
        : ``;
};

export const getCachedLastName = state => {
    return state.cachedFormData.lastName
        ? state.cachedFormData.lastName
        : state.cachedFormData.fullName
        ? state.cachedFormData.fullName.split(' ').pop()
        : ``;
};



// WEBPACK FOOTER //
// ./src/utils/formCaching/helpers.js